import React, { useState, useEffect, useCallback, useRef } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { useRecoilValue } from 'recoil';
import { isMobile } from "react-device-detect";
import * as moment from "moment";
import { useRecoilState } from 'recoil';

import { VehicleHistoryDateState } from './store/VehicleHistoryDateStore';
import * as LocationsApi from "../../../Common/Apis/LocationsApi";
// import LocationMap from "../../GoogleMap/GoogleMap";
import LocationMap from "../../GoogleMap/GoogleMap_New";
import HistoryList from "./VehicleHistoryItems/HistoryList";
import Spinner from "../../../Common/UI/Spinner/Spinner";
import MapWrapper from "../../../Public/Wrapper/MapWrapper";
import MapHeader from "../../../Public/Header/MapHeader";
import { vehicleSearchTypeState, vehicleSearchStrState } from '../../../Common/Store/VehicleSearchStore';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = React.useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

const VehicleHistory = (props) => {

  const pageSize = isMobile ? 20 : 100;

  const queryParams = useQuery();


  const vehicleTypeParam = queryParams.get("vehicleType") ?? "0";

  const searchStrParam = queryParams.get("searchStr") ?? "";


  const VehicleId = props.match.params.id;

  const [historyItem, sethistoryItem] = useState({});
  const [mapData, setMapData] = useState();
  const [selectedVehicle, setselectedVehicle] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [pageNo, setpageNo] = useState(1);
  const [hasMore, sethasMore] = useState(true);
  const [isCenter, setisCenter] = useState(true);

  const [searchVehicleTypeChk, setSearchVehicleTypeChk] = useState();
  const [searchVehicleStrChk, setSearchVehicleStrChk] = useState();

  const [vehicleHistoryDate, setVehicleHistoryDate] = useRecoilState(VehicleHistoryDateState);

  const previousPageNo = usePrevious(pageNo);
  const previousStartDate = usePrevious(vehicleHistoryDate);

  const historyRef = useRef({ vehicleHistoryDate: null, pageNo: 0 });

  const vehicleType = useRecoilValue(vehicleSearchTypeState);
  const vehicleSearchStr = useRecoilValue(vehicleSearchStrState);

  useEffect(() => {
    setVehicleHistoryDate(queryParams.get("date") ?? moment().format("YYYY-MM-DD"));

  }, []);

  useEffect(() => {
    //Make a delay to setup correctly
    const searchTimeout = setTimeout(() => {
      if (searchVehicleTypeChk === undefined) {
        setSearchVehicleTypeChk(vehicleType);
      }

      if (searchVehicleStrChk === undefined) {
        setSearchVehicleStrChk(vehicleSearchStr);
      }

    }, 800);

    return () => {
      clearTimeout(searchTimeout);
    };
  }, [vehicleType, vehicleSearchStr]);


  useEffect(() => {

    if (vehicleSearchStr !== undefined && searchVehicleStrChk !== undefined) {

      if (vehicleType !== searchVehicleTypeChk || vehicleSearchStr !== searchVehicleStrChk) {

        props.history.push("/locate");
      }
    }

  }, [vehicleType, vehicleSearchStr, searchVehicleTypeChk, searchVehicleStrChk]);

  const loadMapData = useCallback(async () => {


    if (!vehicleHistoryDate || !pageNo) {
      return;
    }


    //when change the start date then skip the same request of pageNo
    if (pageNo > 1 && previousPageNo === pageNo) {
      return;
    }

    if (pageNo === 1 && previousPageNo === pageNo && previousStartDate === vehicleHistoryDate) {
      return;
    }


    const queryStartDate = moment(vehicleHistoryDate).format("YYYY-MM-DD");
    const queryEndDate = moment(moment(vehicleHistoryDate).add(1, "d")).format("YYYY-MM-DD");

    try {
      if (pageNo === 1)
        setisLoading(true);


      const resData = await LocationsApi.getVehicleHistory(
        pageNo,
        pageSize,
        VehicleId,
        queryStartDate,
        queryEndDate,
      );

      if (resData) {

        sethasMore(resData.Paging.Next && resData.Paging.Next !== "");

        if (pageNo > 1) {

          setisCenter(false);
          setMapData([...mapData, ...resData.Data.GateReaderReadings]);
        } else {
          setisCenter(true);
          setMapData(resData.Data.GateReaderReadings);
        }
      }
      setisLoading(false);

      //If startdate is changed the loop has to stop
      if (historyRef.current.vehicleHistoryDate === vehicleHistoryDate) {
        //In the desktop view, call the api automatically 
        if (!isMobile && resData.Paging.Next && resData.Paging.Next !== "") {
          setpageNo(pageNo + 1);
        }
      }
    } catch (err) {
      console.log("=================================================err", err);
      setisLoading(false);
    }
  }, [VehicleId, pageNo, previousPageNo, previousStartDate, vehicleHistoryDate]);

  //Change the date
  useEffect(() => {
    setselectedVehicle(null);
    setMapData(null);

    setpageNo(1);

    //Use the UseRef to stop looping when startdate is changed
    historyRef.current.vehicleHistoryDate = vehicleHistoryDate;

    if (vehicleHistoryDate) {


      props.history.push(
        "/history/" +
        VehicleId +
        setParams(
          vehicleTypeParam,
          searchStrParam,
          moment(vehicleHistoryDate).format("YYYY-MM-DD")
        )
      );
    }
  }, [vehicleHistoryDate]);



  //Change page
  //For mobile device FetchMore
  useEffect(() => {

    loadMapData();

  }, [loadMapData, pageNo]);

  useEffect(() => {
    //console.log("useEffect===.first");
    const getVehicleInformation = async (VehicleId) => {
      try {
        setisLoading(true);
        const vehicleinformation = await LocationsApi.getVehicleInformation(
          VehicleId
        );


        sethistoryItem(vehicleinformation);
      } catch (err) {
        console.log("=================================================err", err);
      }
      setisLoading(false);
    };

    getVehicleInformation(VehicleId);
  }, [VehicleId]);





  const setParams = (type, str, date = "") => {
    if (type !== "0" || str !== "" || date !== "") {
      return ("?searchStr=" + str + "&date=" + date + "&exp=" + Date.now());
    }

    return "";
  };

  const clickedVehicle = useCallback((item) => {
    setisCenter(true);
    setselectedVehicle(item);
  }, []);

  const fetchMoreData = () => {
    setpageNo(pageNo + 1);
  };

  const unSelectVehicle = () => {
    setisCenter(false);
    setselectedVehicle(null);
  };

  const closeHistoryView = () => {
    props.history.push("/locate" + setParams(vehicleTypeParam, searchStrParam));
  };



  return (
    <MapWrapper
      header={
        <MapHeader
          closeSidebar={true}
          isOnlyRuc={false}
        />
      }
    >
      <div className="row no-gutters">
        <div id="map" className="map-full">
          <LocationMap
            isUseMarkerLabel={false}
            zoom={mapData?.length > 0 ? 15 : 8}
            locations={mapData}
            selectedVehicle={selectedVehicle}
            unSelectVehicle={unSelectVehicle}
            isPolyline={true}
            isCenter={isCenter}
          />
        </div>
        {historyItem && (
          <HistoryList
            vehicle={historyItem}
            items={mapData}
            clickedVehicle={clickedVehicle}
            hasMore={hasMore}
            fetchMoreData={fetchMoreData}
            closeHistoryView={closeHistoryView}
            selectedVehicle={selectedVehicle}
          />
        )}
        {isLoading && <Spinner active={true} />}
      </div>
    </MapWrapper>
  );
};

export default withRouter(VehicleHistory);
